/**************************************************
 * Nombre:       Seccion_Movimientos_ID
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_COMPARACION,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useRef, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ArrowBack, ManageSearch} from "@mui/icons-material";
import {TIPOSCONTRATO} from "../../Constantes";
import {reducirHash} from "../../CodNegocio/Funciones/reducirHash";
import {useParams} from "react-router-dom";
import {where} from "firebase/firestore";
import {useObtenerColleccionTabla2025Wheres} from "../../Servicios/BD/useObtenerColleccionTabla2025Wheres";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Dialogo_Movimientos_Crear from "../Dialogos/Dialogo_Movimientos_Crear";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import {arrConteoColSemanasAtrasWhereSuma} from "../../Servicios/BD/Contadores_Arr/arrConteoColSemanasAtrasWhereSuma";
import Tarjeta_Valor_Titulo_Grafica from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Valor_Titulo_Grafica";
import Dona_Limpia from "../../Modulo_Graficas/Graficas/Dona_Limpia";
import {contarWheresSuma} from "../../Servicios/BD/Contadores/contarWheresSuma";
import {formatoMonedaGraficas} from "../../Modulo_Graficas/Utilidades/formatoMonedaGraficas";
import Tarjeta_Indicador from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Indicador";
import ic_cartera from '../../Modulo_Graficas/RecursosGraficas/ic_cartera.svg'


const Seccion_Movimientos_ID = () => {
    const params = useParams();
    const refe = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const [totales, setTotales] = useState([])
    const [totalesBonos, setTotalesBonos] = useState([])
    const [totalesRendimientos, setTotalesRendimientos] = useState([])
    const [totalRetornar, setTotalRetornar] = useState(0)
    const [wheres, setWheres] = useState([where('id', '==', 'none')]);
    const {
        props,
        cargarNuevamente
    } = useObtenerColleccionTabla2025Wheres({coleccion: 'movimientos', wheres: wheres, nombreEstado: 'tipo'});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Movimientos_Crear,
        titulo: 'Creando Movimiento',
        realizado: cargarNuevamente
    })
    const [contrato, setContrato] = useState({})

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    const agregarMovimiento = () => {

        let datos = {
            idUsuario: contrato.idUsuario,
            codigo: contrato.codigoUsuario,
            correo: contrato.correo,
            nombre: contrato.nombre,
            minContrato: reducirHash({hash: contrato.hash, largo: 10}),
            idContrato: contrato.id,
        }

        console.log(datos)
        abrir(datos)
    }


    const obtenerDatos = async (tipo, id) => {


        let w = [where('tipo', 'in', [TIPOSCONTRATO[0].nombre, TIPOSCONTRATO[1].nombre]), where(tipo, '==', id)]

        let dox = await arrConteoColSemanasAtrasWhereSuma({
            coleccion: 'movimientos',
            semanasAtras: 16,
            wheres: w,
            propiedad: 'valor'
        })
        setTotales(dox)

        let wBonos = [where('tipo', '==', TIPOSCONTRATO[0].nombre), where(tipo, '==', id)]
        let doxBonos = await arrConteoColSemanasAtrasWhereSuma({
            coleccion: 'movimientos',
            semanasAtras: 16,
            wheres: wBonos,
            propiedad: 'valor'
        })
        setTotalesBonos(doxBonos)

        let wRendimientos = [where('tipo', '==', TIPOSCONTRATO[1].nombre), where(tipo, '==', id)]
        let doxRendimientos = await arrConteoColSemanasAtrasWhereSuma({
            coleccion: 'movimientos',
            semanasAtras: 16,
            wheres: wRendimientos,
            propiedad: 'valor'
        })
        setTotalesRendimientos(doxRendimientos)


        let doxTotal = await contarWheresSuma({coleccion: 'movimientos', propiedad: 'valor', wheres: w})
        setTotalRetornar(doxTotal.data)


        /*  let origenes_ = await arrConteoColPropiedadEstados({
              coleccion: 'pedidos',
              propiedad: 'estado',
              arrEstados: TIPOSCONTRATO.map((it) => it.nombre),
          })*/


    }


    useEffect(() => {

        if (params.tipo && params.id) {

            let tipo = params.tipo
            let id = params.id

            let w = [where(tipo, '==', id)]
            setWheres(w)

            obtenerDoc('contratos', id).then((dox) => {
                if (dox.res) {
                    setContrato(dox.data)
                }
            })

            obtenerDatos(tipo, id).then()

        }

    }, [params]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -3, mb: -3}}>
                    <Button
                        onClick={() => window.history.back()}
                        variant={'text'} startIcon={<ArrowBack/>}>Atras</Button>
                </Grid>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Historial de Bonos y Rendimientos'}
                        subtitulo={'4 Meses Atras'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: 'Total',
                                    data: totales.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Bonos',
                                    data: totalesBonos.map((it) => it.cantidad)

                                },
                                {
                                    name: 'Rendimientos',
                                    data: totalesRendimientos.map((it) => it.cantidad)

                                },
                            ]
                        }
                        labels={totales.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Valor_Titulo_Grafica
                        titulo={'Retornado'}
                        valor={formatoMonedaGraficas(totalRetornar)}
                        Grafica={Dona_Limpia}
                        marginTop={0}
                        height={40}
                        series={[totalRetornar, contrato.valor * 2 - totalRetornar]}
                        labels={['Retornado', 'Por Retornar']}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 2}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Indicador
                        titulo={'Valor Contrato'}
                        valor={formatoMonedaGraficas(contrato.valor)}
                        icono={ic_cartera}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={`Movimientos Contrato (${reducirHash({hash: contrato.hash, largo: 10})})`}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={agregarMovimiento}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Movimientos_ID

const filtros = [
    {
        nombre: 'Valor',
        direccion: 'desc',
        propiedad: 'valor'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y tipo',
        direccion: 'left',
        propiedades: ['consecutivo', 'tipo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: "correo",
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        titulo: 'moneda',
        siTitulo: 'PUNTOS',
        tipo: CASILLA_COMPARACION

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        titulo: 'visible',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Tipo',
        direccion: 'right',
        propiedad: 'tipo',
        tipo: CASILLA_ESTADO,
        estados: [TIPOSCONTRATO[0], TIPOSCONTRATO[1]]
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]